<template>
    <div>
        <el-menu default-active="1" class="el-menu-vertical-demo" @select="handleSelect" @open="handleOpen"
            @close="handleClose" :collapse="isCollapse">
            <el-menu-item index="1">
                <i class="el-icon-s-custom"></i>
                <span slot="title">{{ $t('nav_item_1') }}</span>
            </el-menu-item>
            <el-menu-item index="2">
                <i class="el-icon-bell"></i>
                <span slot="title">{{ $t('nav_item_2') }}</span>
            </el-menu-item>
            <el-menu-item index="3" v-show="role == '1'">
                <i class="el-icon-menu"></i>
                <span slot="title">{{ $t('nav_item_3') }}</span>
            </el-menu-item>
            <el-menu-item index="4" v-show="role == '3'">
                <i class="el-icon-user"></i>
                <span slot="title">{{ $t('nav_item_4') }}</span>
            </el-menu-item>
            <el-menu-item index="5" v-show="role != '2'">
                <i class="el-icon-plus"></i>
                <span slot="title">{{ $t('nav_item_5') }}</span>
            </el-menu-item>
            <el-menu-item index="6" v-show="role == '1'">
                <i class="el-icon-s-order"></i>
                <span slot="title">{{ $t('nav_item_6') }}</span>
            </el-menu-item>
            <el-menu-item index="7" v-show="role == '2'">
                <i class="el-icon-s-order"></i>
                <span slot="title">{{ $t('nav_item_7') }}</span>
            </el-menu-item>
            <!-- Doctor -->
            <el-menu-item index="8" v-show="role == '1'">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">{{ $t('nav_item_8') }}</span>
            </el-menu-item>
            <el-menu-item index="9" v-show="role == '1'">
                <i class="el-icon-chat-dot-square"></i>
                <span slot="title">{{ $t('nav_item_9') }}</span>
            </el-menu-item>
            <el-menu-item index="10" v-show="role == '1'">
                <i class="el-icon-data-analysis"></i>
                <span slot="title">{{ $t('nav_item_10') }}</span>
            </el-menu-item>
            <!-- Patient -->
            <el-menu-item index="11" v-show="role == '2'">
                <i class="el-icon-first-aid-kit"></i>
                <span slot="title">{{ $t('nav_item_11') }}</span>
            </el-menu-item>
            <el-menu-item index="12" v-show="role == '2'">
                <i class="el-icon-data-analysis"></i>
                <span slot="title">{{ $t('nav_item_12') }}</span>
            </el-menu-item>
            <el-menu-item index="13" v-show="role == '2'">
                <i class="el-icon-document-checked"></i>
                <span slot="title">{{ $t('nav_item_13') }}</span>
            </el-menu-item>
            <el-menu-item index="14" v-show="role == '2'">
                <i class="el-icon-monitor"></i>
                <span slot="title">{{ $t('nav_item_14') }}</span>
            </el-menu-item>
            <el-menu-item index="15" v-show="role == '2'">
                <i class="el-icon-date"></i>
                <span slot="title">{{ $t('nav_item_15') }}</span>
            </el-menu-item>
            <el-menu-item index="16" v-show="role == '2'">
                <i class="el-icon-message"></i>
                <span slot="title">{{ $t('nav_item_16') }}</span>
            </el-menu-item>
            <el-menu-item index="17" v-show="role == '2'">
                <i class="el-icon-phone-outline"></i>
                <span slot="title">{{ $t('nav_item_17') }}</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>


<script>
export default {
    data() {
        return {
            isCollapse: false,
            role: sessionStorage.getItem('role', '1')
        };
    },
    mounted() {
        if (window.outerWidth < 600) {
            this.isCollapse = true
        }
    },
    methods: {
        handleSelect(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: 'account' });
                    break;
                case '2':
                    this.$router.push({ name: 'notifications' });
                    break;
                case '3':
                    this.$router.push({ name: 'receptions' });
                    break;
                case '4':
                    this.$router.push({ name: 'profile_staff' });
                    break;
                case '5':
                    this.$router.push({ name: 'create_user' });
                    break;
                case '6':
                    this.$router.push({ name: 'all_users' });
                    break;
                case '7':
                    this.$router.push({ name: 'mychart' });
                    break;

            }
        },
        handleOpen(key, keyPath) {
            // console.log(key, keyPath)
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath);
        }
    }
}
</script>


<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    min-height: 100vh;
}

@media (max-width: 600px) {
    .el-menu--collapse {
        width: 50px !important;
    }

    .el-tooltip {
        padding: 0 15px !important;
    }
}
</style>